// Code generated - EDITING IS FUTILE. DO NOT EDIT.
//
// Generated by:
//     public/app/plugins/gen.go
// Using jennies:
//     TSTypesJenny
//     PluginTsTypesJenny
//
// Run 'make gen-cue' from repository root to regenerate.

// Generated from public/app/plugins/panel/table/panelcfg.cue file.

import * as ui from '@grafana/schema';

export const pluginVersion = "12.4.3";

export interface Options extends ui.TableOptions {}

export interface FieldConfig extends ui.TableFieldOptions {}
